<script>
  import TabButton from "./TabButton.svelte";
  import Gallery from "./Gallery.svelte";

  let activeTab = "2025";

  const setActiveTab = (tab) => {
    activeTab = tab;
  };

  const badmintonWinners = {
    "2025": "Team Tom and Johnny",
    "2023": "Team Lynn and Yashar",
  };
</script>

<header class="tr bg-white pv2" />
<div class="pv5 pv6-ns">
  <div
    class="w-90-ns w-80-xl center flex-l items-start"
    style="max-width: 1400px"
  >
    <div class="w-100 w-75-l ph3 ph4-m ph0-l" style="max-width: 700px">
      <div class="mb3">
        <h1 class="black ma0 pa0 f2 f-subheadline-ns lh-solid lora fw6">
          Another summer to remember.
        </h1>
      </div>
      <div class="mt4 pt3 pt0-ns pt2-l flex items-center">
        <p class="lato ma0 pa0 black-60 f5 f4-ns lh-copy">
          Thanks to all of our friends and family for spending your 4th of July
          with us. We'll see you again next year!
        </p>
      </div>
    </div>
  </div>
</div>
<div class="ph3 ph5-ns nt2">
  <TabButton
    label="2025"
    activeTab={activeTab === "2025"}
    onClick={() => setActiveTab("2025")}
  />
  <TabButton
    label="2024"
    activeTab={activeTab === "2024"}
    onClick={() => setActiveTab("2024")}
  />
  <TabButton
    label="2023"
    activeTab={activeTab === "2023"}
    onClick={() => setActiveTab("2023")}
  />
  <TabButton
    label="2021"
    activeTab={activeTab === "2021"}
    onClick={() => setActiveTab("2021")}
  />
</div>
<div class="bg-white pt3">
  {#if activeTab === "2023" || activeTab === "2025"}
    <div
      class="dib ph4 pv2 mt3 mb2 mh3 mh5-ns br2"
      style="background-color: #FFCE4D"
    >
      <div class="flex items-center">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.00036 3.37726V4.5C6.00036 6.37329 6.85797 8.04568 8.20482 9.14718C8.90537 9.72012 9.73686 10.1372 10.6469 10.3469C11.0811 10.447 11.5341 10.5 12.0004 10.5C12.4666 10.5 12.9196 10.447 13.3539 10.3469C14.2639 10.1372 15.0954 9.72012 15.7959 9.14718C17.1428 8.04568 18.0004 6.37329 18.0004 4.5V3.37726C16.0357 3.12833 14.0332 3 12.0004 3C9.96751 3 7.96498 3.12833 6.00036 3.37726ZM5.14584 1.97821C7.38579 1.66297 9.67426 1.5 12.0004 1.5C14.3265 1.5 16.6149 1.66297 18.8549 1.97821C19.2251 2.03031 19.5004 2.34706 19.5004 2.72089V3.59205C20.2806 3.7165 21.0545 3.86006 21.8215 4.02223C22.2151 4.10543 22.4729 4.48425 22.4059 4.88086C21.9119 7.80752 19.5364 10.0935 16.5652 10.4512C15.9036 10.9594 15.1544 11.36 14.3438 11.6264C14.455 12.2888 14.6626 12.9182 14.9518 13.5H15.3754C16.4109 13.5 17.2504 14.3395 17.2504 15.375V18.075C18.962 18.4225 20.2504 19.9358 20.2504 21.75C20.2504 22.1642 19.9146 22.5 19.5004 22.5H4.50036C4.08615 22.5 3.75036 22.1642 3.75036 21.75C3.75036 19.9358 5.03868 18.4225 6.75036 18.075V15.375C6.75036 14.3395 7.58983 13.5 8.62536 13.5H9.04891C9.3381 12.9182 9.54573 12.2888 9.65691 11.6264C8.84633 11.36 8.0971 10.9594 7.43553 10.4512C4.46429 10.0935 2.08886 7.80751 1.5948 4.88085C1.52784 4.48424 1.78567 4.10543 2.1792 4.02223C2.94624 3.86006 3.72013 3.7165 4.50036 3.59205V2.72089C4.50036 2.34706 4.77566 2.03031 5.14584 1.97821ZM4.52464 5.10765C4.0958 5.17813 3.66898 5.25456 3.24426 5.33687C3.62553 6.54082 4.42959 7.55714 5.48182 8.21154C4.95205 7.28304 4.6147 6.23018 4.52464 5.10765ZM11.1234 11.9492C11.0282 12.4858 10.8812 13.0045 10.6877 13.5H13.313C13.1195 13.0045 12.9725 12.4858 12.8774 11.9492C12.5895 11.9828 12.2968 12 12.0004 12C11.7039 12 11.4113 11.9828 11.1234 11.9492ZM8.25036 18H15.7504V15.375C15.7504 15.1679 15.5825 15 15.3754 15H8.62536C8.41826 15 8.25036 15.1679 8.25036 15.375V18ZM18.5189 8.21154C19.5711 7.55714 20.3752 6.54083 20.7565 5.33687C20.3317 5.25456 19.9049 5.17813 19.4761 5.10765C19.386 6.23018 19.0487 7.28304 18.5189 8.21154ZM5.37839 21H18.6223C18.3135 20.1261 17.48 19.5 16.5004 19.5H7.50036C6.5207 19.5 5.68727 20.1261 5.37839 21Z"
            fill="#08081b"
          />
        </svg>
        <span class="pl3 lato black-80"
          >Congrats to this year's badminton tournament winners, {badmintonWinners[
            activeTab
          ]}!</span
        >
      </div>
    </div>
  {/if}
  <Gallery year={activeTab} />
</div>
